<template>
  <div class="settings-error">
    <h2 class="headline">{{title}}</h2>
    <v-form class="form">
      <v-card
        v-for="(value, key) in currentData"
        :key="key"
      >
        <content-editor
          :label="`Message if ${key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()}`"
          multiLine
          v-model="currentData[key]"
        />
      </v-card>

      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
      >
        Update form
      </v-btn>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import { mergeDeepRight } from 'ramda'

  export default {
    name: 'FormMessages',
    props: {
      title: {
        type: String,
        default: 'Messages'
      },
      formData: {
        type: Object,
        default: {
          invalidToken: '',
          noToken: ''
        }
      },
      formType: {
        type: String,
        default: "blitz_registration"
      }
    },
    data () {
      return {
        currentData: {},
        closedRoutes: ['form-messages']
      }
    },
    watch: {
      getMessageSettings () {
        this.setFormData()
      },
    },
    computed: {
      ...mapGetters(['getMessageSettings'])
    },
    methods: {
      ...mapActions(['updateForm', 'getFormByType']),
      setFormData () {
        this.currentData = mergeDeepRight(this.formData, this.getMessageSettings)
      },
      submitForm () {
        this.updateForm({
          messages: this.currentData
        })
      }
    },
    async created () {
      if (!this.closedRoutes.includes(this.$route.name)) await this.getFormByType(this.formType)
      this.setFormData()
    },
    mounted () {
      setTimeout(window.scrollTo(0, 0),0)
    }
  }
</script>

<style lang="scss" scoped>
  .settings-error {
    max-width: 480px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/FormMessages/index.vue